import { LitComponent } from "./lit-component";
import { FloatingUiController } from "../controllers/FloatingUiController";

import type { FloatSettings } from "../controllers/FloatingUiController";
import type { PropertyDeclarations } from "lit";

export class Counter extends LitComponent {
  static properties: PropertyDeclarations = {
    value: { type: Number },
    floating: { type: Object },
    showNumber: { type: Boolean, attribute: "show-number" },
    showBrackets: { type: Boolean, attribute: "show-brackets" },
  };

  value? = 0;
  showNumber? = false;
  showBrackets? = false;
  floating?: FloatSettings;

  private floatingUi: FloatingUiController = new FloatingUiController(this);

  render() {
    const text = this.showNumber ? this.value : "";

    const classes = [
      "wk-counter",
      this.showBrackets && "wk-brackets",
      this.floating && "wk-bubble",
      this.floating && !this.showNumber && "wk-dot",
    ]
      .filter((v) => !!v)
      .join(" ");

    return this.lit.html`<span class=${classes}>${text}</span>`;
  }

  createRenderRoot() {
    return this;
  }
}

if (!customElements.get("wk-counter")) {
  customElements.define("wk-counter", Counter);
}

declare global {
  interface HTMLElementTagNameMap {
    "wk-counter": Counter;
  }
}
